<template>
  <BasePage :pageTitle="__DICT__.menuOptions.Events" show-menu show-footer>
    <div v-for="event in sortedEvents" :key="event.name" class="card mb-2">
      <router-link :to="`/event/${event.reference.split('-')[2]}`">
        <div class="card-header">
          <div class="card-status-top bg-primary"></div>
          <h4 class="card-title">{{ event.name.split(" - ")[0] }}</h4>
          <div class="card-actions">
            <div class="d-flex align-items-center">
              <span v-if="event.startDateTime" class="text-muted me-3">
                <!-- {{ formatDateTime(event.lastEntry) }} -->
                {{ event.startDateTime }}
              </span>
              <span class="badge bg-primary text-white">
                {{ getParticipantCount(event) }}<br/>{{ __DICT__.participants }}
              </span>
            </div>
          </div>
        </div>
      </router-link>
    </div>

    <div v-if="isLoading" class="text-center mt-3">
      <div class="spinner-border text-primary" role="status"></div>
      <span class="ms-2">{{ __DICT__.loading }}</span>
    </div>
  </BasePage>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useWeekStore } from '@/stores/week.js'
import BasePage from "@/components/BasePage.vue"

const weekStore = useWeekStore()
const weekData = ref([])
const isLoading = ref(true)

const events = computed(() => {
  const eventMap = new Map()
  const canViewAll = weekStore.repObj?.level >= 3

  weekData.value.forEach(passenger => {
    // Handle multiple events per passenger
    const passengerEvents = passenger.allocPlaces?.filter(place => place.event) || []

    passengerEvents.forEach(place => {
      const event = place.event
      if (!event) return

      // Extract reference ID safely
      const referenceId = event.reference?.split('-')[2]
      if (!canViewAll && event.reference?.split("-")[0].toUpperCase() !== __DICT__.brand.toUpperCase()) return;
      if (!referenceId) return

      if (!eventMap.has(referenceId)) {
        eventMap.set(referenceId, {
          ...event,
          participantCount: 1,
          participants: [passenger]
        })
      } else {
        const existingEvent = eventMap.get(referenceId)
        existingEvent.participantCount++
        existingEvent.participants?.push(passenger)
      }
    })
  })

  return Array.from(eventMap.values())
})
const sortedEvents = computed(() => {
  return events.value.sort((a, b) => {
    // Sort by lastEntry timestamp if available
    if (a.startDateTime && b.startDateTime) {
      return new Date(a.startDateTime) - new Date(b.startDateTime)
    }
    // Fall back to name sorting if lastEntry not available
    return a.name.localeCompare(b.name)
  })
})

function formatDateTime(dateTimeString) {
  if (!dateTimeString) return ''
  const date = new Date(dateTimeString)
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function getParticipantCount(event) {
  return event.participantCount || 0
}

onMounted(() => {
  weekData.value = weekStore.weekData || []
  isLoading.value = !weekStore.weekData
})
</script>

<style scoped>

</style>